import i18n from '@/i18n'

export default [
  {
    name: 'OriginProtocolOptions',
    value: [
      { label: i18n.t('domainManage.protocolReference'),
        value: '2',
        desc: i18n.t('domainManage.protocolReferenceDesc') }, // 协议跟随
      { label: 'HTTP', value: '0', desc: i18n.t('domainManage.protocolHttpDesc') }, //
      { label: 'HTTPS', value: '1', desc: i18n.t('domainManage.protocolHttpsDesc') } //
    ]
  },
  {
    name: 'OriginHostTypeOptions',
    value: [
      { label: i18n.t('domainManage.useAccessDomain'), value: 'refer', desc: i18n.t('domainManage.useAccessDomainDesc') },
      { label: i18n.t('domainManage.useCustomDomain'), value: 'custom', desc: i18n.t('domainManage.useCustomDomainDesc') }
    ]
  },
  {
    name: 'CertificateTypeOptions',
    value: [
      { label: i18n.t('domainManage.noSetting'), value: 0 },
      { label: i18n.t('domainManage.customCerti'), value: 1 }
    ]
  },
  {
    name: 'SecurityTypeOptions',
    value: [
      { label: i18n.t('domainManage.useSysSuggest'), value: 'SYSTEM', desc: i18n.t('domainManage.useSysSuggestDesc') },
      { label: i18n.t('domainManage.domainReference'), value: 'REFER', desc: i18n.t('domainManage.domainReferenceDesc') }
    ]
  },
  {
    name: 'SearchWordTypeOptions',
    value: [
      { label: i18n.t('common.domain'), value: 'DOMAIN' },
      { label: i18n.t('common.domainGroup'), value: 'DOMAIN_GROUP' },
      { label: i18n.t('domainManage.originConfig'), value: 'ORIGIN' }
    ]
  },
  {
    name: 'RouteOptions',
    value: [
      { label: i18n.t('purchase.globalNoMainland'), value: 2, desc: i18n.t('purchase.globalNoMainlandDesc') }, // 全球（不包含中国大陆）
      { label: i18n.t('purchase.highPerfHK'), value: 4, desc: i18n.t('purchase.highPerfHKDesc') } // 高性能链路（大陆-香港）
    ]
  },
  {
    name:'QueryStringCache',
    value: [
      { label: i18n.t('domainManage.noSetting'), value: '0' },
      { label: i18n.t('domainManage.keepAll'), value: '1' },
      { label: i18n.t('domainManage.ignoreAll'), value: '2' },
      { label: i18n.t('domainManage.keepPartParam'), value: '3' },
      { label: i18n.t('domainManage.deletePartParam'), value: '4' }
    ]
  }
]

